import { register, find } from '../../../Javascript/Utils.js'

const componentPrefix = 'mFactCounter-'

const FactCounter = el => {
  if (!el.dataset.isanimated) {
    return false
  }
  createCounterObserver(el)
}

/**
 * Animated the TextContent of a HTMLElement
 * @param {HTMLElement} el - The Component
 * @param {integer} start where animation should start at
 * @return void
 */

const animateCounter = (el, start = 0) => {
  const animationSpeed = getAnimationSpeed(el)

  if (el.dataset.wastriggered) {
    return false
  }

  // set a data attribute so the dom knows the animation was triggered to avoid performance issues and that the animation repeats over and over again when scrolling out and in the element
  el.dataset.wastriggered = true

  let current = start
  // get the Children of the component where the animation takes place
  const valueContainer = find(`.${componentPrefix}Value`, el)
  // get the end value which was initialy loadet by the server rendering and treat it as the end of the counting animation
  const end = parseInt(valueContainer.textContent, 10)
  // calculdat the range of the animation
  const range = end - start
  // calculate the animation steps
  const increment = end > start ? 1 : -1
  // calculate the animation speed
  const stepTime = Math.abs(Math.floor(animationSpeed / range))
  // animate via interval
  const timer = setInterval(() => {
    current += increment
    valueContainer.innerHTML = current
    if (current === end) {
      // clear interval ( end animation ) if the end has reached
      clearInterval(timer)
    }
  }, stepTime)
}

/**
 * gets the animationspeed from a data attribute of the element
 * @param {HTMLElement} el - The Component
 * @return integer
 */
const getAnimationSpeed = (el) => {
  let animationSpeed

  switch (el.dataset.animationspeed) {
    case 'slow':
      animationSpeed = 10000
      break
    case 'medium':
      animationSpeed = 5000
      break
    case 'fast':
      animationSpeed = 1000
      break
    default:
      animationSpeed = 5000
  }

  return animationSpeed
}

/**
 * observes the intersection of the counter element to check if the count element is visible in the viewport
 * @param {HTMLElement} el - The Component
 * @return void
 */

const createCounterObserver = (el) => {
  const onIntersection = (entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting && !document.querySelector('html').getAttribute('data-reduced-motion')) {
        // if element is visible due intersection start the counter
        animateCounter(el)
      }
    }
  }
  const observer = new window.IntersectionObserver(onIntersection)
  observer.observe(el)
}

register('FactCounter', FactCounter)
